import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { MatomoTracker } from 'ngx-matomo-client';

/**
 * Custom constent modal
 * to ask for user consent for analytics tracking
 * @class MatomoConsentComponent
 * @typedef {MatomoConsentComponent}
 */
@Component( {
    selector: 'app-matomo-consent',
    templateUrl: './matomo-consent.component.html',
    styleUrls: ['./matomo-consent.component.scss'],
    standalone: false
} )
export class MatomoConsentComponent {
    readonly tracker = inject( MatomoTracker );
    #cookieService = inject( CookieService );
    #lang = 'en';

    checked = false;
    linkPrivacy = '';

    acceptAll = $localize`:@@cookies-accept-all:Accept all cookies`;
    rejectAll = $localize`:@@cookies-reject-all:Reject all cookies`;

    allowPerformanceTracking = $localize`:@@performance-tracking-allow:Allow performance tracking`;
    disallowPerformanceTracking = $localize`:@@performance-tracking-disallow:Do not allow performance tracking`;

    /**
     * Creates an instance of MatomoConsentComponent.
     * @class
     * @param data object of data properies passed into the modal
     * @param data.simple - flag whether to show default dialog
     * @param data.checked - flag if cosent was given before
     * @param dialogRef reference on dialog modal
     */
    constructor(
        @Inject( MAT_DIALOG_DATA ) public data: { simple: boolean; checked: boolean },
        public dialogRef: MatDialogRef<MatomoConsentComponent>
    ) {
        this.checked = this.data.checked;
        this.setPrivacyLink();
    }

    /** set legal links in footer depending on user language */
    setPrivacyLink() {
        // show links to legal pages depending on language //
        const cookieExists: boolean = this.#cookieService.check( 'language' );

        if ( cookieExists ) {
            this.#lang = this.#cookieService.get( 'language' );
        } else {
            this.#lang = navigator.language;
        }

        switch ( this.#lang ) {
            case 'de':
            case 'de-DE':
            case 'de-AT':
            case 'de-CH':
                this.linkPrivacy = 'https://www.riege.com/de/datenschutz/';
                break;
            default:
                this.linkPrivacy = 'https://www.riege.com/privacy/';
        }
    }

    /**
     * helper function to handle consent choice
     */
    handleConsent() {
        if ( this.checked ) {
            this.tracker.forgetUserOptOut();
            this.tracker.rememberConsentGiven();
        } else {
            this.tracker.optUserOut();
        }
        this.dialogRef.close( this.checked );
    }
}
